import moment from 'moment';

const DISPLAY_DATE_FORMAT = 'DD.MM.YYYY';

// Tarih Date, moment, ISO metni ya da "DD.MM.YYYY" metni olarak gelebilir; gecersizse null doner.
// Formatsiz moment("05.09.2026") js Date'e dusup 9 Mayis okudugu icin formatlar acikca ve strict verilir.
export function toDate(value) {
  if (value === null || value === undefined || value === '') return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  if (moment.isMoment(value)) return value.isValid() ? value.toDate() : null;

  const parsed = moment(String(value).trim(), [DISPLAY_DATE_FORMAT, moment.ISO_8601], true);
  return parsed.isValid() ? parsed.toDate() : null;
}

// Backend ve autosave icin "DD.MM.YYYY"; tarih gecersizse bos metin doner
export function formatDisplayDate(value) {
  const date = toDate(value);
  return date ? moment(date).format(DISPLAY_DATE_FORMAT) : '';
}



// WEBPACK FOOTER //
// ./src/utils/date.js